import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useMutation, useQueryCache } from 'react-query';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { loginUser } from '../api/auth';
import { NotificationContext } from '../context/NotificationProvider';
import Notification from '../components/notification';

const transition = {
  duration: 0.3,
  ease: [0.6, 0.05, -0.01, 0.9],
};
const pageVariants = {
  initial: { scale: 1.3, opacity: 0, transition },
  enter: { scale: 1, opacity: 1, transition },
  exit: { scale: 0, opacity: 0, transition },
};

const Login = () => {
  const history = useHistory();
  const cache = useQueryCache();
  const { sendNotification } = useContext(NotificationContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [logUserIn, { isLoading }] = useMutation(loginUser, {
    onSuccess: (user) => {
      cache.invalidateQueries('user');
      cache.setQueryData('user', user);
      history.push('/');
    },
    onError: (error) => {
      sendNotification({
        type: 'warning',
        message:
          error.response.status === 403
            ? error.response.statusText
            : error.response.data,
      });
    },
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    await logUserIn({ email, password });
  };

  return (
    <motion.div
      initial="initial"
      animate="enter"
      exit="exit"
      variants={pageVariants}
      className="relative bg-white shadow-md rounded-b max-w-screen-sm text-center m-auto py-20"
    >
      <Notification />
      <p className="text-xl font-bold mb-4 uppercase">Login</p>
      <form
        onSubmit={handleLogin}
        className="grid grid-cols-3 gap-2 items-center max-w-xs m-auto"
      >
        <label className="col-span-1 mr-auto label" htmlFor="ip-email">
          Email ID :
        </label>
        <input
          id="ip-email"
          placeholder="Email"
          className="col-span-2 input"
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <label className="col-span-1 mr-auto label" htmlFor="ip-password">
          Password :
        </label>
        <input
          id="ip-password"
          placeholder="Password"
          className="col-span-2 input"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          type="submit"
          disabled={isLoading}
          className="col-span-3 btn-primary mt-2"
        >
          Login
          {isLoading ? (
            <FontAwesomeIcon icon="circle-notch" spin className="ml-2" />
          ) : (
            <FontAwesomeIcon icon="arrow-right" className="ml-2" />
          )}
        </button>
      </form>
    </motion.div>
  );
};
export default Login;
